var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { MarkdownWrapper, MarkdownHeading1, MarkdownHeading2, MarkdownHeading3, MarkdownHeading4, MarkdownHeading5, MarkdownHeading6, MarkdownParagraph, MarkdownBold, MarkdownItalic, MarkdownUnderline, MarkdownStrikethrough, MarkdownLink, MarkdownList, MarkdownOrderedList, MarkdownListItem, MarkdownBlockquote, MarkdownCode, MarkdownPre, MarkdownHr, MarkdownTable, MarkdownTableHead, MarkdownTableBody, MarkdownTableRow, MarkdownTableCell, MarkdownTableHeader, } from "./MarkdownRenderer.styled";
import { Spinner } from "../Spinner";
var MarkdownRenderer = function (_a) {
    var content = _a.content, _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.error, error = _c === void 0 ? false : _c, className = _a.className;
    if (loading) {
        return _jsx(Spinner, {});
    }
    if (error || !content) {
        return _jsx(MarkdownHeading5, { children: "Something went wrong" });
    }
    return (_jsx(MarkdownWrapper, { className: className, children: _jsx(Markdown, { rehypePlugins: [rehypeRaw], components: {
                // Headings
                h1: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownHeading1, __assign({}, props));
                },
                h2: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownHeading2, __assign({}, props));
                },
                h3: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownHeading3, __assign({}, props));
                },
                h4: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownHeading4, __assign({}, props));
                },
                h5: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownHeading5, __assign({}, props));
                },
                h6: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownHeading6, __assign({}, props));
                },
                // Text formatting
                p: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownParagraph, __assign({}, props));
                },
                strong: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownBold, __assign({}, props));
                },
                em: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownItalic, __assign({}, props));
                },
                u: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownUnderline, __assign({}, props));
                },
                del: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownStrikethrough, __assign({}, props));
                },
                a: function (_a) {
                    var href = _a.href, props = __rest(_a, ["href"]);
                    return (_jsx(MarkdownLink, __assign({ href: href, target: "_blank", rel: "noopener noreferrer" }, props)));
                },
                // Lists
                ul: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownList, __assign({}, props));
                },
                ol: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownOrderedList, __assign({}, props));
                },
                li: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownListItem, __assign({}, props));
                },
                // Blockquote
                blockquote: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownBlockquote, __assign({}, props));
                },
                // Code blocks
                code: function (_a) {
                    var className = _a.className, props = __rest(_a, ["className"]);
                    var match = /language-(\w+)/.exec(className || "");
                    var isInline = !className || !className.startsWith("language-");
                    return !isInline ? (_jsx(MarkdownCode, __assign({ className: match ? className : "" }, props))) : (_jsx(MarkdownCode, __assign({}, props)));
                },
                pre: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownPre, __assign({}, props));
                },
                // Horizontal rule
                hr: function () { return _jsx(MarkdownHr, {}); },
                // Tables
                table: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownTable, __assign({}, props));
                },
                thead: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownTableHead, __assign({}, props));
                },
                tbody: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownTableBody, __assign({}, props));
                },
                tr: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownTableRow, __assign({}, props));
                },
                td: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownTableCell, __assign({}, props));
                },
                th: function (_a) {
                    var props = __rest(_a, []);
                    return _jsx(MarkdownTableHeader, __assign({}, props));
                },
            }, children: typeof content === "string" ? content : "" }) }));
};
export default MarkdownRenderer;
//# sourceMappingURL=MarkdownRenderer.js.map